import PropTypes from 'prop-types';
import { joinClassNames as c } from 'Shared/util/styles';
import styles from './switch.css';


const Switch = ({
  active,
  onChange,
  disabled,
  label,
  id,
  className,
}) => (
  <div className={c(styles.container, (disabled && styles.disabled), className)}>
    <label
      htmlFor={id || 'switch_0'}
      className={c(styles.switch, (disabled && styles.disabled))}
    >
      <input
        id={id || 'switch_0'}
        type="checkbox"
        checked={active}
        onChange={!disabled ? onChange : null}
        readOnly={disabled}
      />
      <span className={styles.slider} />
    </label>
    <span className={styles.label}>
      {label}
    </span>
  </div>
);

Switch.propTypes = {
  active: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  id: PropTypes.string,
  className: PropTypes.string,
};

export default Switch;
